import http from "./axios";
import qs from "qs";

let service = http();
// post请求
export default function httpPost({ url, data = {}, params = {}, config = {} }) {
  return new Promise((resolve, reject) => {
    service
      .post(
        url,
        config.headers &&
          config.headers["Content-Type"] &&
          config.headers["Content-Type"] === "application/json;charset=utf-8"
          ? params
          : qs.stringify(params),
        config
      )
      .then(res => {
        resolve(res?.data);
      })
      .catch(err => {
        reject(err);
      });
    // if (config.headers && !config.formData) {
    //   // 临时处理文件上传post无法传formData参数处理
    //   // config.withCredentials = true;
    //   // axios.post(url, params, config).then((res) => {
    //   //   resolve(res.data);
    //   // }).catch(err => {
    //   //   reject(err);
    //   // });
    // } else {
    //   service.post(url, params, config).then((res) => {
    //     resolve(res.data);
    //   }).catch(err => {
    //     reject(err);
    //   });
    // }
  });
}
